import { useRouter } from 'next/router'

import { Box } from '@chakra-ui/react'

import { WORKFLOW } from '@/utils/routes'

import { WorkflowsTable } from './WorkflowsTable'

export const WorkflowsTab = () => {
  const router = useRouter()

  return (
    <Box overflow='hidden' pos='relative'>
      <Box
        h={{ base: 'calc(100vh - 175px)', md: 'calc(100vh - 138px)' }}
        overflow='scroll'
        overflowX='auto'
        px={{ md: 0, lg: 6 }}
        textAlign='center'
        transition='ease-in-out'
        transitionDuration='300ms'
        transitionProperty='all'
        w='full'
      >
        <WorkflowsTable
          onRowClick={(versionId) =>
            router.push(`${WORKFLOW}?versionId=${versionId}`)
          }
        />
      </Box>
    </Box>
  )
}
